import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { ErrorReference } from '../../../../shared/error/error-reference'
import '../../../../shared/sso-workspace/sso-workspace.scss'

// An audited ops action (replay, resend, park, drain, disable): what it
// does in one sentence, an optional reason (required: true makes it
// mandatory, for changes the server refuses without one) (C-4 ActionReason, at most 500
// characters, kept in the audit trail), and the action. The workspace's
// confirmation look (confirm-dialog.js): modal, Escape is Cancel, focus on
// the reason. `error` keeps it open with the server's sentence; `failure`
// adds its reference.
export const ReasonDialog = ({ open, title, body, confirmText, danger = false, required = false, busy, error, failure, onConfirm, onCancel, children }) => {
  const [reason, setReason] = useState('')

  // A new question (opened again, or for another row) starts blank.
  useEffect(() => {
    if (open) setReason('')
  }, [open, title, body])

  useEffect(() => {
    if (!open) return undefined
    const onKey = e => { if (e.key === 'Escape') { e.stopPropagation(); onCancel() } }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onCancel])

  if (!open) return null

  return createPortal(
    <div className="sw-drawer justify-content-center align-items-center" onClick={e => { if (e.target === e.currentTarget) onCancel() }}>
      <div className="sw-dialog" role="alertdialog" aria-modal="true" aria-labelledby="nf-reason-title" aria-describedby="nf-reason-body">
        <h2 className="h5" id="nf-reason-title">{title}</h2>
        <p className="sw-hint" id="nf-reason-body">{body}</p>
        {children}
        <label className="sw-label" htmlFor="nf-reason">{required ? 'Reason' : 'Reason (optional)'}</label>
        <textarea id="nf-reason" className="form-control mb-3" rows={2} maxLength={500} autoFocus value={reason} onChange={e => setReason(e.target.value)} />
        {error && <p className="text-danger small" role="alert">{error}</p>}
        {error && <ErrorReference error={failure} className="mb-3" />}
        <div className="sw-dialog-actions">
          <button type="button" className="btn sw-btn" onClick={onCancel}>Cancel</button>
          <button type="button" className={`btn ${danger ? 'sw-btn-danger' : 'sw-btn-primary'}`} disabled={busy || (required && !reason.trim())} onClick={() => onConfirm(reason.trim())}>{confirmText}</button>
        </div>
      </div>
    </div>,
    document.body
  )
}
